/**
 * @typedef {object} MatchByMatchState
 * @property {MatchByMatchRequestDetails[]} requests
 * @property {object} data
 */

/**
 * @typedef {object} MatchByMatchRequestDetails
 * @property {string} id
 */
